/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import WrongIcon from '@assets/wrong.svg';
import classes from './Wrong.module.css';

export const Wrong = ({
  text, title, btnText, btnLink,
}) => {
  const navigate = useNavigate();

  const onClickBack = () => {
    navigate(btnLink || '/');
  };

  return (
    <section className={classes.content}>
      <img src={WrongIcon} alt="" className={classes.icon} />
      {title ? <section className={classes.title}>{title}</section> : null}
      {text ? <section className={classes.text}>{text}</section> : null}
      <Button
        style={{ textTransform: 'none' }}
        className={classes.back_btn}
        onClick={onClickBack}
        sx={{
          marginTop: '31px',
          padding: '8px 16px',
          border: 'solid 1px #BABFC3',
          borderRadius: '2px',
          color: '#202223',
          fontSize: '14px',
          lineHeight: '20px',
        }}
      >
        {btnText || 'Back to home'}
      </Button>
    </section>
  );
};
